var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.is_mem_load
    ? _c(
        "div",
        { staticClass: "mem_fields" },
        [
          _c("mem_draw_field", {
            key: "mem_number",
            attrs: {
              field_val: _vm.mem_number,
              field_type: "number",
              field_name: "Номер",
            },
          }),
          _vm._v(" "),
          _c("mem_draw_field", {
            key: "added",
            attrs: {
              field_val: _vm.mem_date,
              field_type: "added",
              field_name: "Дата створення",
            },
          }),
          _vm._v(" "),
          _c("mem_draw_field", {
            key: "mem_question_title",
            attrs: {
              field_val: _vm.mem_question_title,
              field_type: "mem_question_title",
              field_name: "Питання",
            },
          }),
          _vm._v(" "),
          _c("mem_draw_field", {
            key: "title",
            attrs: {
              can_edit: true,
              field_val: _vm.mem_title,
              field_type: "title",
              field_name: "Тема",
            },
            on: { title_edit: _vm.edit_title },
          }),
          _vm._v(" "),
          _c("mem_draw_field", {
            key: "mem_organization",
            attrs: {
              field_val: _vm.mem_organization_title,
              field_type: "mem_organization_title",
              field_name: "Організація",
            },
          }),
          _vm._v(" "),
          _c("mem_draw_field", {
            key: "mem_service",
            attrs: {
              field_val: _vm.mem_service_title,
              field_type: "mem_service_title",
              field_name: "Служба",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "mem_links" }, [
            _c("div", { staticClass: "form-group" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "simple_text" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "edit_text d-inline-block pl-1 cursor-pointer",
                      on: { click: _vm.edit_links },
                    },
                    [_c("fa", { attrs: { icon: _vm.faEdit } })],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.mem_links, function (item) {
                    return _vm.mem_links.length > 0
                      ? _c("div", { staticClass: "d-block" }, [
                          _c(
                            "a",
                            {
                              staticClass: "mem_link mt-2",
                              attrs: { target: "_blank", href: item.link },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(item.title) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e()
                  }),
                ],
                2
              ),
            ]),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "control-label" }, [
      _c(
        "label",
        { attrs: { id: "jform_reasons-lbl", for: "jform_reasons" } },
        [_vm._v("\n                    Документ підстава\n                ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }